import { render, staticRenderFns } from "./right_3.vue?vue&type=template&id=8f99d204&scoped=true&"
import script from "./right_3.vue?vue&type=script&lang=js&"
export * from "./right_3.vue?vue&type=script&lang=js&"
import style0 from "./right_3.vue?vue&type=style&index=0&id=8f99d204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f99d204",
  null
  
)

export default component.exports